import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name radio-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNDEwMyAxMC43ODUyQzEwLjE1MjkgMTEuMTIxOCAxMCAxMS41NDI1IDEwIDExLjk5OUMxMCAxMy4xMDM2IDEwLjg5NTQgMTMuOTk5IDEyIDEzLjk5OUMxMi41MDc3IDEzLjk5OSAxMi45NzEzIDEzLjgwOTggMTMuMzI0IDEzLjQ5OCIgLz4KICA8cGF0aCBkPSJNMTYuMTk5MiA3LjgwMDc4QzE3LjQ3MzkgOS4wNzU0OSAxOC4wNDIyIDEwLjgxMDkgMTcuOTAzOSAxMi41MTM0IiAvPgogIDxwYXRoIGQ9Ik0xOS4wOTk2IDQuODk4NDRDMjIuMDg5MiA3Ljg4ODA0IDIyLjc4NzEgMTIuMjg3OSAyMS4xOTMyIDE1LjkzNiIgLz4KICA8cGF0aCBkPSJNMiAyTDIyIDIyIiAvPgogIDxwYXRoIGQ9Ik00Ljg5OTYxIDE5LjA5ODRDMC45OTk2MDkgMTUuMTk4NCAwLjk5OTYwOSA4Ljc5ODQ0IDQuODk5NjEgNC44OTg0NCIgLz4KICA8cGF0aCBkPSJNNy43OTkyMiAxNi4xOTkyQzUuNjY4MjggMTQuMDY4MyA1LjUxMTY1IDEwLjY0OTggNy4zMjkzMSA4LjI1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/radio-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const RadioOff: IconNode = [
  [
    'path',
    {
      d: 'M10.4103 10.7852C10.1529 11.1218 10 11.5425 10 11.999C10 13.1036 10.8954 13.999 12 13.999C12.5077 13.999 12.9713 13.8098 13.324 13.498',
    },
  ],
  ['path', { d: 'M16.1992 7.80078C17.4739 9.07549 18.0422 10.8109 17.9039 12.5134' }],
  ['path', { d: 'M19.0996 4.89844C22.0892 7.88804 22.7871 12.2879 21.1932 15.936' }],
  ['path', { d: 'M2 2L22 22' }],
  ['path', { d: 'M4.89961 19.0984C0.999609 15.1984 0.999609 8.79844 4.89961 4.89844' }],
  ['path', { d: 'M7.79922 16.1992C5.66828 14.0683 5.51165 10.6498 7.32931 8.25' }],
];

export default RadioOff;
